import PropTypes from 'prop-types';
import React from 'react';
import cx from 'classnames';
import styles from './Label.css';
import appStyles from '../../../styles/app.css';

const Label = ({ text, name, style, hidden, className, ...props }) => (
<label
    className={cx(styles.label, {
        [appStyles.hidden]: hidden,
    }, className)}
    style={style}
    htmlFor={name}
    aria-label={text}
    {...props}
>
    {text}
</label>
);

Label.propTypes = {
    text: PropTypes.node,
    name: PropTypes.string,
    className: PropTypes.string,
    style: PropTypes.object,
    hidden: PropTypes.bool,
};

Label.defaultProps = {
    hidden: false,
};

export default Label;



// WEBPACK FOOTER //
// ./src/client/Components/Forms/Label/Label.js